import { useContext } from 'react';

import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/index';

import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

import { ExternalPatientContext } from '../constants';
import { IframeMessageType, ModalType } from '../types';

export const AIImpactButton = () => {
  const { trackEvent } = useTrackEvent();
  const externalPatientContext = useContext(ExternalPatientContext);

  return (
    <Button
      className="vai-h-6 !vai-px-2 !vai-py-1 vai-bg-zinc-950 hover:vai-bg-zinc-950 vai-border !vai-border-solid vai-border-zinc-800 !vai-rounded-full vai-flex vai-items-center vai-justify-center"
      onClick={() => {
        trackEvent(mixpanelEvents.externalAiImpactModalOpen, {
          ...externalPatientContext,
          source: 'AI_IMPACT_BUTTON',
        });
        window.parent.postMessage(
          {
            type: IframeMessageType.MODAL_OPEN,
            payload: {
              type: ModalType.AI_IMPACT,
              patientId: externalPatientContext.patientId,
              imageId: externalPatientContext.imageId,
              externalPatientId: externalPatientContext.externalPatientId,
              externalImageId: externalPatientContext.externalImageId,
            },
          },
          '*',
        );
      }}
    >
      <p className="vai-text-white vai-font-inter vai-font-medium vai-text-[12px]">
        <Trans>Practice AI Impact</Trans>
      </p>
      <span role="img" aria-label="Rocket">
        🚀
      </span>
    </Button>
  );
};
